import { render, staticRenderFns } from "./contact-list-select.vue?vue&type=template&id=6d9b9d5a&scoped=true&"
import script from "./contact-list-select.vue?vue&type=script&setup=true&lang=js&"
export * from "./contact-list-select.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./contact-list-select.vue?vue&type=style&index=0&id=6d9b9d5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9b9d5a",
  null
  
)

export default component.exports